export const AuthActionTypes = {
    SetUserInfo: '[Auth] Set User Info',
    LogOut: '[Auth] Logout',
    SetCustomerInfo: '[Auth] Set Customer Info',
};
